<template>
  <el-dialog
    class="add-data-migration-task-dialog common-dialog"
    :title="title"
    :visible.sync="dialogVisible"
    top="25vh"
  >
    <el-steps :active="step" simple>
      <el-step title="步骤 1（添加任务）" icon="el-icon-edit"></el-step>
      <el-step title="步骤 2（配置原链信息）" icon="el-icon-upload"></el-step>
      <el-step title="步骤 3（配置目标链信息）" icon="el-icon-picture"></el-step>
    </el-steps>

    <div v-if="step == 0" class="task-info mTop20">
      <el-form
        ref="taskInfoForm"
        :rules="rules"
        :model="taskInfoForm"
        :label-width="`${adaptationVars.formLabelWidth}px`"
        class="demo-dynamic"
      >
        <el-form-item class="server-long" prop="taskName" label="任务名称">
          <el-input v-model="taskInfoForm.task_name"></el-input>
        </el-form-item>

        <el-form-item class="server-long" prop="taskName" label="任务类型">
          <el-select v-model="taskInfoForm.origin_chain_type" placeholder="请选择">
            <el-option value="fabric" label="Fabric1.4 To 长安链2.2.0"
              >Fabric1.4 To 长安链2.2.0</el-option
            >
          </el-select>
        </el-form-item>

        <el-form-item class="server-long" prop="transfer_height" label="迁移高度">
          <el-input-number
            v-model="taskInfoForm.transfer_height"
            controls-position="right"
            :min="0"
            style="width: 100%;"
            :step-strictly="true"
          ></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="step == 0" slot="footer" class="dialog-footer">
      <el-button :disabled="!task_id" @click="taskInfoNext('taskInfoForm')">下一步</el-button>
      <el-button type="primary" @click="save('taskInfoForm')">保存</el-button>
    </div>

    <div v-if="step == 1" class="task-info mTop20">
      <el-form
        ref="taskChainInfoForm"
        :rules="rules"
        :model="taskChainInfoForm"
        :label-width="`${adaptationVars.formLabelWidth}px`"
        class="demo-dynamic"
      >
        <el-form-item class="server-long" prop="channel_name" label="链ID">
          <el-input v-model="taskChainInfoForm.channel_name"></el-input>
        </el-form-item>

        <el-form-item class="server-long" prop="user_name" label="用户名称">
          <el-input v-model="taskChainInfoForm.user_name"></el-input>
        </el-form-item>

        <el-form-item class="server-long" prop="file_certs" label="用户证书">
          <el-upload
            action=""
            :before-upload="beforeUploadUser"
            :on-change="onSuccessUser"
            :on-error="onErrorUser"
            :limit="1"
            :file-list="fileListUser"
            :auto-upload="false"
          >
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item class="server-long" prop="file_sdk" label="config文件">
          <el-upload
            action=""
            :before-upload="beforeUploadConfig"
            :on-change="onSuccessConfig"
            :on-error="onErrorConfig"
            :limit="1"
            :file-list="fileListConfig"
            :auto-upload="false"
          >
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>

    <div v-if="step == 1" slot="footer" class="dialog-footer">
      <el-button @click="chainInfoPrev()">上一步</el-button>
      <el-button @click="chainInfoNext()">下一步</el-button>
      <el-button type="primary" @click="testIsCommunicate('taskChainInfoForm')"
        >测试连通性</el-button
      >
      <el-button type="primary" @click="chainInfoSave('taskChainInfoForm')">保存</el-button>
    </div>

    <div v-if="step == 2" class="task-info mTop20">
      <el-form
        ref="certTypeForm"
        :rules="rules"
        :model="certTypeForm"
        :label-width="`${adaptationVars.formLabelWidth}px`"
        class="demo-dynamic"
      >
        <el-form-item class="server-long" prop="taskName" label="证书类型">
          <el-select v-model="certTypeForm.auth_type" placeholder="请选择">
            <el-option value="permissionedWithCert" label="permissionedWithCert"
              >permissionedWithCert</el-option
            >
            <el-option value="public" label="public">public</el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="server-long" prop="org_id" label="组织ID">
          <el-input v-model="certTypeForm.org_id"></el-input>
        </el-form-item>

        <el-form-item class="server-long" prop="file_certs" label="用户证书">
          <el-upload
            action=""
            :before-upload="beforeUploadUser"
            :on-change="onSuccessFile"
            :on-error="onErrorFile"
            :limit="1"
            :file-list="fileList"
            :auto-upload="false"
          >
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="step == 2" slot="footer" class="dialog-footer">
      <el-button @click="certInfoPrev()">上一步</el-button>
      <el-button type="primary" @click="certTypeSave('certTypeForm')">保存</el-button>
      <el-button type="primary" @click="handleComplete('certTypeForm')">完成</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'AddDataMigration',
  components: {},
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      title: '新建数据迁移任务',
      dialogVisible: false,
      step: 0,
      isStep: false,
      task_id: '',
      isEdit: false,
      taskInfoForm: {
        task_name: '',
        origin_chain_type: 'fabric',
        origin_chain_version: '1.4',
        target_chain_type: 'chainmaker',
        target_chain_version: '2.2.0',
        transfer_height: null,
        task_id: ''
      },
      taskChainInfoForm: {
        task_id: '',
        channel_name: '',
        user_name: ''
      },
      certTypeForm: {
        auth_type: '',
        org_id: ''
      },
      fileListUser: [],
      fileListConfig: [],
      fileList: [],
      rules: {},
      editData: {},
      serviceAddress: '',
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },

  mounted() {
    this.step = 0
  },
  methods: {
    taskInfoNext() {
      this.step = 1
    },
    getEditData(data) {
      let url = `${this.serviceAddress}/transfer/task_info/${data.task_id}`
      this.$apis.datamigration.getEditData(url, {}).then(res => {
        if (res.code != 200) {
          this.$message.error(res.message)
        } else {
          this.editData = res.result
          this.taskInfoForm.task_name = this.editData.task.task_name
          this.taskInfoForm.origin_chain_type = this.editData.task.origin_chain_type
          this.taskInfoForm.origin_chain_version = this.editData.task.origin_chain_version
          this.taskInfoForm.target_chain_type = this.editData.task.target_chain_type
          this.taskInfoForm.target_chain_version = this.editData.task.target_chain_version
          this.taskInfoForm.transfer_height = this.editData.task.transfer_height
          this.taskInfoForm.task_id = this.editData.task.task_id
          this.task_id = this.editData.task.task_id
          console.log(this.task_id)
          this.taskChainInfoForm.task_id = this.editData.task_id
          this.taskChainInfoForm.channel_name = this.editData.channel_name
          this.taskChainInfoForm.user_name = this.editData.user_name

          this.certTypeForm.auth_type = this.editData.key_type
          this.certTypeForm.org_id = this.editData.org_id
          if (JSON.parse(localStorage.getItem('data_migration_file_certs'))) {
            this.fileListUser = JSON.parse(localStorage.getItem('data_migration_file_certs'))
            this.fileListConfig = JSON.parse(localStorage.getItem('data_migration_file_sdk'))
            this.fileList = JSON.parse(localStorage.getItem('data_migration_file'))
          }

          console.log(this.fileListUser)
          this.$message.success('获取成功...')
        }

        return
      })
    },
    save() {
      let params = {}
      params.origin_chain_type = this.taskInfoForm.origin_chain_type
      params.origin_chain_version = this.taskInfoForm.origin_chain_version
      params.target_chain_type = this.taskInfoForm.target_chain_type
      params.target_chain_version = this.taskInfoForm.target_chain_version
      params.task_id = this.task_id
      params.task_name = this.taskInfoForm.task_name
      params.transfer_height = Number(this.taskInfoForm.transfer_height)
      let url = `${this.serviceAddress}/transfer/upsert_task?task_id=${this.task_id}`
      this.$apis.datamigration.createTask(url, params).then(res => {
        if (res.code != 200) {
          this.$message.error(res.message)
        } else {
          this.isStep = true
          this.task_id = this.taskChainInfoForm.task_id = res.result.task_id
          this.$message.success('保存成功...')
        }
        return
      })
    },
    beforeUploadUser() {},
    onSuccessUser(file) {
      this.fileListUser = []
      this.fileListUser.push(file)
      localStorage.setItem('data_migration_file_certs', JSON.stringify(this.fileListUser))
      return false // 阻止自动上传
    },
    onErrorUser(err) {
      console.log(err)
    },
    beforeUploadConfig() {},
    onSuccessConfig(file) {
      this.fileListConfig = []
      this.fileListConfig.push(file)
      localStorage.setItem('data_migration_file_sdk', JSON.stringify(this.fileListConfig))
      return false
    },
    onErrorConfig(err) {
      console.log(err)
    },
    beforeUploadFile() {},
    onSuccessFile(file) {
      this.fileList = []
      this.fileList.push(file)
      localStorage.setItem('data_migration_file', JSON.stringify(this.fileList))

      return false // 阻止自动上传
    },
    onErrorFile(err) {
      console.log(err)
    },
    chainInfoSave() {
      const formData = new FormData()
      console.log(this.fileListUser)
      formData.append('file_certs', this.fileListUser[0].raw)
      formData.append('file_sdk', this.fileListConfig[0].raw)
      let url = `${this.serviceAddress}/transfer/create_task/upsert_origin_chain?task_id=${this.task_id}&channel_name=${this.taskChainInfoForm.channel_name}&user_name=${this.taskChainInfoForm.user_name}`
      this.$apis.datamigration.createTask(url, formData).then(res => {
        if (res.code != 200) {
          this.$message.error(res.message)
        } else {
          this.isStep = true
          this.$message.success('保存成功...')
        }
        return
      })
    },
    testIsCommunicate() {
      // http://10.143.12.109:12091/transfer/test_origin_chain/%7Btask_id%7D?task_id=f31927421dfd4aaeabcea129e3ddae91

      let formData = {}
      let url = `${this.serviceAddress}/transfer/test_origin_chain/${this.task_id}`
      this.$apis.datamigration.testTask(url, formData).then(res => {
        if (res.code != 200) {
          this.$message.error(res.message)
        } else {
          this.$message.success('测试成功成功...')
        }
        return
      })
    },
    //证书类型保存
    certTypeSave() {
      const formData = new FormData()
      console.log(this.fileListUser)
      formData.append('file', this.fileList[0].raw)

      let url = `${this.serviceAddress}/transfer/create_task/upsert_target_chain?task_id=${this.task_id}&auth_type=${this.certTypeForm.auth_type}&org_id=${this.certTypeForm.org_id}`

      this.$apis.datamigration.addTargetChain(url, formData).then(res => {
        if (res.code != 200) {
          this.$message.error(res.message)
        } else {
          this.isStep = true
          this.$message.success('保存成功...')
        }

        return
      })
    },
    chainInfoPrev() {
      this.step = 0
    },
    certInfoPrev() {
      this.step = 1
    },
    chainInfoNext() {
      this.step = 2
    },
    handleComplete() {
      this.dialogVisible = false
      this.$emit('update:list')
    },
    handleOpen(serviceAddress, data = {}, isEdit = false) {
      this.serviceAddress = serviceAddress
      if (isEdit) {
        this.title = '编辑数据迁移任务'
        this.getEditData(data)
      } else {
        this.title = '新建数据迁移任务'
      }
      this.dialogVisible = true
    },
    handleCancel() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.add-data-migration-task-dialog.common-dialog {
  @include adaptation(
    (
      --add-data-migration-task-dialog-margin: 0 40px 20px
    )
  );
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-steps {
    margin: var(--add-data-migration-task-dialog-margin);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }
  }
}
</style>
